
import {CasualLeaveEN} from "./casual-leave/en"

export const CasualAndCompensatoryEN = {
    ...CasualLeaveEN
}